import { REQUEST_STATE } from './constants'

export const SETS = {
  MESSAGES: 'Messages',
  MESSAGES_WIDGET: 'MessagesWidget',
  MESSAGES_INFO: 'MessagesInfo',
}

export const CONSTANTS = {
  CONNECTION_STATE: 'CONNECTION_STATE',
}

const createStateSet = type => ({
  stateKey: `${type}State`,
  modifiedKey: `${type}Modified`,
  statusCodeKey: `${type}StatusCode`,
  messageKey: `${type}Message`,
  dataKey: `${type}Data`,
})

export const stateSets = {
  [SETS.MESSAGES]: createStateSet(SETS.MESSAGES),
  [SETS.MESSAGES_INFO]: createStateSet(SETS.MESSAGES_INFO),
  [SETS.MESSAGES_WIDGET]: createStateSet(SETS.MESSAGES_WIDGET),
}

const createStateFromSet = set => {
  return {
    [set.stateKey]: REQUEST_STATE.STATE_INITIAL,
    [set.modifiedKey]: undefined,
    [set.statusCodeKey]: undefined,
    [set.messageKey]: undefined,
    [set.dataKey]: undefined,
  }
}

export default {
  ...createStateFromSet(stateSets[SETS.MESSAGES]),
  ...createStateFromSet(stateSets[SETS.MESSAGES_INFO]),
  ...createStateFromSet(stateSets[SETS.MESSAGES_WIDGET]),
  [CONSTANTS.CONNECTION_STATE]: undefined,
}
